import inputData from "@/data/input";
import selectionsData from "@/data/selections";

const {
    clients: clientsSelectionKey,
    distributionFileTypes: distributionFileTypesSelectionKey,
    preOrderTypes: preOrderTypesSelectionKey,
    territories: territoriesSelectionKey,
    trackFormats: trackFormatsSelectionKey,
    tracks: tracksSelectionKey,
} = selectionsData.keys;

const {
    autoComplete: autoCompleteInputType,
    date: dateInputType,
    multiAutoComplete: multiAutoCompleteInputType,
} = inputData.types;

const {
    availableForImmersiveDate: availableForImmersiveDateInputName,
    client: clientInputName,
    fileType: fileTypeInputName,
    preOrderDate: preOrderDateInputName,
    preOrderType: preOrderTypeInputName,
    releaseDate: releaseDateInputName,
    salesStartDate: salesStartDateInputName,
    streamStartDate: streamStartDateInputName,
    territory: territoryInputName,
    track: trackInputName,
    trackFormats: trackFormatsInputName,
} = inputData.names;

const {
    availableForImmersiveDate: availableForImmersiveDateInputLabel,
    client: clientInputLabel,
    fileType: fileTypeInputLabel,
    preOrderDate: preOrderDateInputLabel,
    preOrderType: preOrderTypeInputLabel,
    releaseDate: releaseDateInputLabel,
    salesStartDate: salesStartDateInputLabel,
    streamStartDate: streamStartDateInputLabel,
    territory: territoryInputLabel,
    track: trackInputLabel,
    trackFormats: trackFormatsInputLabel,
} = inputData.labels;

const releaseDistributionFormData = [
    {
        col: { xs: 12 },
        isAsyncMenu: true,
        label: clientInputLabel,
        name: clientInputName,
        selectionKey: clientsSelectionKey,
        type: autoCompleteInputType,
    },
    {
        col: { xs: 12 },
        isAsyncMenu: true,
        label: territoryInputLabel,
        name: territoryInputName,
        selectionKey: territoriesSelectionKey,
        type: autoCompleteInputType,
    },
    {
        col: { xs: 12 },
        isAsyncMenu: true,
        label: trackFormatsInputLabel,
        name: trackFormatsInputName,
        selectionKey: trackFormatsSelectionKey,
        type: multiAutoCompleteInputType,
    },
    {
        col: { xs: 12 },
        isAsyncMenu: true,
        label: fileTypeInputLabel,
        name: fileTypeInputName,
        selectionKey: distributionFileTypesSelectionKey,
        type: autoCompleteInputType,
    },
    {
        col: { xs: 12 },
        label: releaseDateInputLabel,
        name: releaseDateInputName,
        notApple: true,
        type: dateInputType,
    },
    {
        col: { xs: 12 },
        isApple: true,
        label: salesStartDateInputLabel,
        name: salesStartDateInputName,
        type: dateInputType,
    },
    {
        col: { xs: 12 },
        isApple: true,
        label: streamStartDateInputLabel,
        name: streamStartDateInputName,
        type: dateInputType,
    },
    {
        col: { xs: 12 },
        isApple: true,
        label: availableForImmersiveDateInputLabel,
        name: availableForImmersiveDateInputName,
        type: dateInputType,
    },
    {
        col: { xs: 12 },
        isApple: true,
        label: preOrderDateInputLabel,
        name: preOrderDateInputName,
        type: dateInputType,
    },
    {
        col: { xs: 12 },
        isApple: true,
        isAsyncMenu: true,
        label: preOrderTypeInputLabel,
        name: preOrderTypeInputName,
        selectionKey: preOrderTypesSelectionKey,
        type: autoCompleteInputType,
    },
    {
        col: { xs: 12 },
        isApple: true,
        isAsyncMenu: true,
        label: trackInputLabel,
        name: trackInputName,
        selectionKey: tracksSelectionKey,
        type: multiAutoCompleteInputType,
    },
];

export default releaseDistributionFormData;
